import React from "react";

const TimerSVG = () => {
  return (
    <svg
      viewBox="0 0 744 341"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 w-full h-full opacity-10"
      preserveAspectRatio="none"
    >
      <g opacity="1">
        <g opacity="1">
          <path
            opacity="0.7"
            d="M216.495 425.916C152.444 347.878 155.547 222.898 274.808 132.896C370.938 60.3504 640.678 -24.9624 545.178 -259.16"
            stroke="white"
            stroke-width="1.5"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M203.549 427.794C142.955 344.5 150.58 215.531 277.695 127.281C378.538 57.2699 643.968 -20.7083 557.538 -252.073"
            stroke="white"
            stroke-width="1.4559"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M190.605 429.66C133.463 341.116 145.539 208.101 280.578 121.659C386.072 54.123 647.261 -16.4653 569.886 -244.988"
            stroke="white"
            stroke-width="1.4118"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M177.658 431.537C123.963 337.735 140.432 200.622 283.461 116.036C393.544 50.9341 650.547 -12.2192 582.242 -237.908"
            stroke="white"
            stroke-width="1.3677"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M164.711 433.413C114.475 334.357 135.258 193.096 286.347 110.421C400.979 47.6993 653.837 -7.96561 594.601 -230.821"
            stroke="white"
            stroke-width="1.3235"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M151.761 435.283C104.986 330.978 130.05 185.493 289.23 104.798C408.37 44.4033 657.122 -3.7198 606.956 -223.742"
            stroke="white"
            stroke-width="1.2794"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M138.821 437.156C95.4942 327.594 124.803 177.837 292.117 99.1824C415.736 41.0649 660.42 0.529878 619.316 -216.655"
            stroke="white"
            stroke-width="1.2353"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M125.875 439.034C85.9986 324.221 119.51 170.121 295 93.561C423.077 37.6845 663.706 4.77761 631.665 -209.569"
            stroke="white"
            stroke-width="1.1912"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M112.925 440.904C76.5073 320.836 114.204 162.346 297.877 87.9425C430.388 34.2638 666.985 9.02825 644.018 -202.478"
            stroke="white"
            stroke-width="1.1471"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M99.9853 442.776C67.0146 317.451 108.883 154.512 300.77 82.323C437.713 30.8051 670.29 13.2737 656.385 -195.395"
            stroke="white"
            stroke-width="1.1029"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M87.0385 444.653C57.5262 314.073 103.544 146.63 303.653 76.6998C445.014 27.3025 673.575 17.5196 668.733 -188.312"
            stroke="white"
            stroke-width="1.0588"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M74.0889 446.522C48.0277 310.692 98.1952 138.698 306.53 71.0812C452.31 23.7747 676.866 21.7732 681.094 -181.224"
            stroke="white"
            stroke-width="1.0147"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M61.149 448.395C38.5389 307.314 92.8502 130.724 309.416 65.4653C459.596 20.2136 680.145 26.0233 693.442 -174.141"
            stroke="white"
            stroke-width="0.9706"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M48.203 450.273C29.0471 303.93 87.4959 122.699 312.304 59.8511C466.896 16.6274 683.442 30.274 705.802 -167.052"
            stroke="white"
            stroke-width="0.9265"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M35.2517 452.143C19.5583 300.552 82.1455 114.633 315.186 54.2283C474.19 13.0141 686.728 34.5204 718.15 -159.969"
            stroke="white"
            stroke-width="0.8824"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M22.3058 454.019C10.0594 297.17 76.7941 106.529 318.07 48.6049C481.487 9.37038 690.014 38.766 730.506 -152.889"
            stroke="white"
            stroke-width="0.8382"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M9.3653 455.892C0.570067 293.793 71.3656 98.0289 320.963 42.9862C488.749 5.46996 693.31 43.0164 742.872 -145.805"
            stroke="white"
            stroke-width="0.7941"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M-3.58529 457.762C-8.92219 290.408 66.1051 90.2168 323.838 37.367C496.102 2.04225 696.596 47.2622 755.22 -138.722"
            stroke="white"
            stroke-width="0.75"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
        </g>
        <g opacity="0.7">
          <path
            opacity="0.7"
            d="M237.262 -17.2547C364.625 -123.676 505.562 -116.685 592.128 -101.387C666.511 -88.2433 772.649 -41.9082 772.649 -41.9082"
            stroke="white"
            stroke-width="1.5"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M230.175 -8.12233C354.41 -112.408 492.991 -107.815 580.012 -92.9235C657.365 -79.9087 765.029 -33.4176 771.945 -27.5061"
            stroke="white"
            stroke-width="1.4583"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M223.096 1.00649C344.208 -101.137 480.393 -98.7272 567.905 -84.4632C648.188 -71.382 757.415 -24.9378 771.245 -13.1149"
            stroke="white"
            stroke-width="1.4167"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M208.926 19.2624C323.793 -78.6087 455.241 -80.8544 543.675 -67.5515C629.873 -54.5898 742.168 -7.9869 769.83 15.6774"
            stroke="white"
            stroke-width="1.3333"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M201.839 28.3938C313.579 -67.3424 442.669 -71.9373 531.56 -59.0886C620.713 -46.1995 734.546 0.495524 769.115 30.0754"
            stroke="white"
            stroke-width="1.2917"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M194.755 37.5154C303.371 -56.0786 430.099 -63.0484 519.455 -50.6396C611.573 -37.8387 726.937 8.97123 768.422 44.4625"
            stroke="white"
            stroke-width="1.25"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M249.571 439.124C160.975 365.701 63.783 154.172 187.669 46.6495C293.157 -44.8097 417.537 -54.1625 507.34 -42.174C602.423 -29.4797 719.314 17.4564 767.707 58.8633"
            stroke="white"
            stroke-width="1.2083"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M229.342 445.65C144.318 364.992 60.1374 160.999 180.582 55.7822C282.946 -33.5348 404.97 -45.2852 495.225 -33.7098C593.275 -21.1334 711.684 25.9443 767.004 73.2657"
            stroke="white"
            stroke-width="1.1667"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M209.111 452.188C127.663 364.282 56.4923 167.826 173.499 64.9034C272.742 -22.2828 392.41 -36.4307 483.113 -25.257C584.134 -12.8099 704.064 34.4166 766.292 87.6536"
            stroke="white"
            stroke-width="1.125"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M188.88 458.726C111 363.578 52.8478 174.653 166.413 74.0363C262.532 -11.0078 379.839 -27.5789 470.999 -16.7926C574.981 -4.48916 696.442 42.9006 765.589 102.056"
            stroke="white"
            stroke-width="1.0833"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M168.651 465.252C94.3408 362.861 49.1988 181.472 159.33 83.1575C252.321 0.24825 367.285 -18.7472 458.888 -8.33991C565.846 3.81156 688.827 51.38 764.882 116.451"
            stroke="white"
            stroke-width="1.0417"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M148.419 471.789C77.6845 362.151 45.5573 188.306 152.243 92.2894C242.11 11.5222 354.719 -9.91906 446.773 0.12349C556.699 12.1086 681.204 59.863 764.174 130.846"
            stroke="white"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M128.195 478.323C61.0333 361.45 41.9198 195.129 145.164 101.418C231.903 22.7858 342.161 -1.09418 434.673 8.57953C547.578 20.3829 673.596 68.3386 763.474 145.237"
            stroke="white"
            stroke-width="0.9583"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M107.959 484.853C44.3736 360.733 38.2748 201.956 138.073 110.543C221.696 34.049 329.599 7.72321 422.554 17.0364C538.426 28.6548 665.969 76.8149 762.767 159.632"
            stroke="white"
            stroke-width="0.9167"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M87.7347 491.388C27.7177 360.025 34.6254 208.776 130.994 119.673C211.488 45.3135 317.046 16.5263 410.446 25.4974C529.291 36.9084 658.347 85.2997 762.059 174.028"
            stroke="white"
            stroke-width="0.875"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M67.5026 497.926C11.0543 359.32 30.9798 215.604 123.907 128.806C201.278 56.5886 304.496 25.1835 398.327 33.9547C520.163 44.9563 650.723 93.7836 761.351 188.423"
            stroke="white"
            stroke-width="0.8333"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M47.2737 504.453C-5.59865 358.601 27.3417 222.427 116.823 137.928C191.066 67.8455 291.936 34.0389 386.215 42.4083C511.021 53.2806 643.103 102.257 760.651 202.815"
            stroke="white"
            stroke-width="0.7917"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
          <path
            opacity="0.7"
            d="M27.0424 510.991C-63.0102 231.349 164.748 33.2877 374.101 50.8724C501.873 61.6082 635.481 110.74 759.937 217.214"
            stroke="white"
            stroke-width="0.75"
            stroke-miterlimit={10}
            stroke-linecap="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default TimerSVG;
